import { render, staticRenderFns } from "./DamLayout.vue?vue&type=template&id=01f586f0"
import script from "./DamLayout.vue?vue&type=script&lang=js"
export * from "./DamLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports